export default "__VITE_ASSET__0500ff10__"